import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Section from './Section';

var BirFormStep = /*#__PURE__*/function (_Component) {
  _inherits(BirFormStep, _Component);

  function BirFormStep() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BirFormStep);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BirFormStep)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.proceededLoopingGroups = [], _this.getStepValidationState = function (step) {
      var stepErrors = _this.props.stepErrors;

      if (!!stepErrors[step]) {
        return 'invalid';
      }

      if (stepErrors[step] === null) {
        return 'valid';
      }

      return 'untouched';
    }, _this.renderStepNavigation = function (currentStep, toStep, jumpToStep) {
      var stepsNames = _this.props.stepsNames;
      var upperSteps = [];

      var _loop = function _loop(i) {
        var stepValidationState = _this.getStepValidationState(i);

        upperSteps.push(React.createElement('div', {
          key: i,
          className: 'stepper stepper-vertical stepper-inactive'
        }, React.createElement('button', {
          type: 'button',
          id: "step-title-".concat(i),
          onClick: function onClick() {
            return jumpToStep(i);
          },
          className: "\n              step-header\n              ".concat(stepValidationState === 'invalid' ? 'step-error' : '', "\n              ").concat(stepValidationState === 'valid' ? 'step-valid' : '', "\n            ")
        }, React.createElement('span', {
          className: 'step-number',
          notranslate: 'true'
        }, i), React.createElement('span', {
          className: 'step-title'
        }, stepsNames[i - 1]))));
      };

      for (var i = currentStep; i < toStep; i++) {
        _loop(i);
      }

      return upperSteps;
    }, _this.renderSection = function (sectionItem, sectionIndex, sections) {
      var _this$props = _this.props,
          handleChange = _this$props.handleChange,
          uploadingFiles = _this$props.uploadingFiles,
          files = _this$props.files,
          fields = _this$props.fields,
          country = _this$props.country,
          language = _this$props.language;
      return React.createElement(Section, {
        key: sectionIndex,
        fields: fields,
        sections: sections,
        sectionItem: sectionItem,
        sectionIndex: sectionIndex,
        handleChange: handleChange,
        uploadingFiles: uploadingFiles,
        files: files,
        country: country,
        language: language
      });
    }, _temp));
  }

  _createClass(BirFormStep, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          stepNum = _this$props2.stepNum,
          totalSteps = _this$props2.totalSteps,
          stepData = _this$props2.stepData,
          handleChange = _this$props2.handleChange,
          handleSubmit = _this$props2.handleSubmit,
          onFinalSubmit = _this$props2.onFinalSubmit,
          jumpToStep = _this$props2.jumpToStep,
          lastStep = _this$props2.lastStep,
          submitting = _this$props2.submitting,
          _this$props2$uploadin = _this$props2.uploadingFiles,
          uploadingFiles = _this$props2$uploadin === void 0 ? [] : _this$props2$uploadin,
          hideSubmitButton = _this$props2.hideSubmitButton;
      var isSubmitDisabled = submitting || !!uploadingFiles.length;
      return React.createElement('form', {
        onSubmit: handleSubmit,
        onChange: function onChange(event) {
          var _event$target = event.target,
              name = _event$target.name,
              value = _event$target.value;
          var file = event.target.files && event.target.files[0];
          handleChange(name, value, file);
        }
      }, this.renderStepNavigation(1, stepNum, jumpToStep), React.createElement('div', {
        className: 'stepper stepper-vertical'
      }, totalSteps > 1 && React.createElement('button', {
        type: 'button',
        className: 'step-header',
        id: "step-title-".concat(stepNum)
      }, React.createElement('span', {
        className: 'step-number',
        notranslate: 'true'
      }, stepNum), React.createElement('span', {
        className: 'step-title'
      }, stepData.title)), React.createElement('div', {
        className: totalSteps > 1 ? 'stepper-content' : ''
      }, stepData.sections.map(this.renderSection), lastStep && !hideSubmitButton && React.createElement('div', {
        className: 'submit-block'
      }, React.createElement('button', {
        type: 'button',
        onClick: onFinalSubmit,
        disabled: isSubmitDisabled,
        className: 'Btn-default Btn-default-primary submit-btn'
      }, 'Submit')))), this.renderStepNavigation(stepNum + 1, totalSteps + 1, jumpToStep));
    }
  }]);

  return BirFormStep;
}(Component);

BirFormStep.propTypes = {
  stepData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  lastStep: PropTypes.bool.isRequired,
  stepNum: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  stepsNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  stepErrors: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  hideSubmitButton: PropTypes.bool,
  country: PropTypes.string,
  language: PropTypes.string
};
export default reduxForm({
  form: 'birForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(BirFormStep);